import {Component} from '@angular/core';
import {LanguageService} from '../../../shared/services/language.service';

@Component({
    selector: 'course-edit-instructor-support-article',
    template: `
        <ng-container i18n="@@support.articles.editInstructor">
            <ol>
                <li>
                    <span>Go to the <a routerLink="/organization/instructors">Instructors Overview</a>.</span>
                </li>
                <li>
                    <span>Find the instructor in the list or use the search field to find the instructor.</span>
                </li>
                <li>
                    <span>
                        Click on the three dots on the right side of the instructor.
                        <br />
                        <img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/editInstructorBtn.png" />
                    </span>
                </li>
                <li>
                    <span>
                        Click <strong>Edit</strong> in the menu that opens.
                    </span>
                </li>
                <li>
                    <div>
                        <p>A window with three tabs appears:</p>

                        <h2>Account details</h2>
                        <p>Update the desired fields:</p>
                        <ul>
                            <li>
                                The instructor's <strong>first name</strong>
                            </li>
                            <li>
                                The instructor's <strong>name</strong>
                            </li>
                            <li>
                                The instructor's <strong>e-mail</strong>
                            </li>
                            <li>
                                <strong>Username:</strong> the instructor can log in with this username. The username is automatically generated when creating the instructor, but can be changed as desired.
                            </li>
                            <li>
                                <strong>Role:</strong> choose if it's an instructor or an administrator.
                                <p>
                                    <a
                                        routerLink="/support/organizations/instructors/instructor-administrator"
                                        mat-stroked-button
                                        color="primary"
                                        class="supportLink"
                                    >Instructor or administrator?</a>
                                </p>
                            </li>
                        </ul>
                        <p>
                            <img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/editInstructorAccount.png" />
                        </p>

                        <h2>Preferences</h2>
                        <p>Update the desired fields:</p>
                        <ul>
                            <li>
                                <span><strong>Language:</strong> you can set the default language for new instructors in the <a routerLink="/organization/settings">Organization Settings</a>. This field allows you to set a different language for specific instructors.</span>
                            </li>
                            <li>
                                <span><strong>Course:</strong> you can set the default course for new instructors in the <a routerLink="/organization/settings">Organization Settings</a>. This field allows you to set a different course for specific instructors.</span>
                            </li>
                            <li>
                                <span><strong>Apple keyboard:</strong> Apple keyboards have a slightly different layout. If the instructor uses an Apple keyboard, you can indicate this here. The course will then be adjusted accordingly.</span>
                            </li>
                            <li>
                                <span><strong>Sound effects and music:</strong> turn sound and music in the course and in games on or off.</span>
                            </li>
                        </ul>
                        <p>
                            <img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/editInstructorPreferences.png" />
                        </p>

                        <h2>Accessibility</h2>
                        <p>Select an accessibility preset or toggle individual accessibility settings on or off.</p>
                        <p>
                            <img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/editInstructorAccessibility.png" />
                        </p>
                    </div>
                </li>
                <li>
                    <span>
                        Click <strong>Save</strong> to save your changes.
                    </span>
                </li>
            </ol>
        </ng-container>
    `
})
export class EditInstructorSupportArticleComponent {
    constructor(
        public languageService: LanguageService
    ) {}
}
